// Limite de dias del rango de descarga en tableros tipo calendar.
// Reemplaza a maxAllowedDays de Firestore: el limite se define solo aqui.
export const DEFAULT_MAX_DOWNLOAD_DAYS = 31;
export const EXTENDED_MAX_DOWNLOAD_DAYS = 90;

// Correos con limite extendido. Ojo: esta lista viaja en el bundle JS y el
// backend no valida el rango, asi que es un limite de UX, no de seguridad.
export const EXTENDED_DOWNLOAD_EMAILS: string[] = [
  'c.moreno@lucro-app.com',
  'afrestrepo@postobon.com.co',
  'nagarcia@postobon.com.co',
];

export function getMaxDownloadDays(
  email: string | null | undefined,
  extendedEmails: string[] = EXTENDED_DOWNLOAD_EMAILS
): number {
  const normalizado = (email ?? '').trim().toLowerCase();
  if (!normalizado) return DEFAULT_MAX_DOWNLOAD_DAYS;
  const extendido = extendedEmails.some(e => e.trim().toLowerCase() === normalizado);
  return extendido ? EXTENDED_MAX_DOWNLOAD_DAYS : DEFAULT_MAX_DOWNLOAD_DAYS;
}
